/** Gedeelde stijlbouwstenen voor de publieke (marketing/info)pagina's,
 *  afgeleid van de homepage-redesign en docs/DESIGN.md: autumn-tokens,
 *  Fraunces-koppen, terracotta als actiekleur (wit op #C8381E ≈ 4.6:1, AA —
 *  het eerdere goud haalde dat niet), stille goud-eyebrows en zachte kaarten
 *  zonder harde randen. */

/** Paginakop (h1) — centreert op smalle schermen, links vanaf md. */
export const pageTitle = {
  fontSize: { xs: "2.4rem", sm: "3rem" },
  letterSpacing: "-0.015em",
  mb: 2,
} as const;

/** Intro onder de paginakop. */
export const lead = {
  fontSize: "1.15rem",
  lineHeight: 1.65,
  color: "text.secondary",
  mb: 5,
} as const;

/** Tussenkop (h2) in lange informatiepagina's, met het korte gouden
 *  streepje uit het feitenblok op de homepage als stille wegwijzer. */
export const h2Rule = {
  fontSize: { xs: "1.45rem", sm: "1.6rem" },
  mt: 7,
  mb: 1.5,
  "&::before": {
    content: '""',
    display: "block",
    width: 36,
    borderTop: "2px solid var(--accent-300)",
    pb: 2,
  },
} as const;

/** Lopende tekst. */
export const paragraph = { mb: 2, color: "text.secondary", lineHeight: 1.7 } as const;

/** Stil sectielabel (eyebrow) in AA-goud. */
export const eyebrow = {
  display: "block",
  fontSize: ".8rem",
  fontWeight: 700,
  letterSpacing: ".08em",
  textTransform: "uppercase",
  color: "var(--accent-700)",
  mb: 1.5,
} as const;

/** Primaire actie — terracotta, AA. */
export const ctaSx = {
  textTransform: "none",
  bgcolor: "primary.main",
  color: "#fff",
  "&:hover": { bgcolor: "primary.dark" },
} as const;

/** Zachte kaart: ruimte + schaduw i.p.v. rand. */
export const softCard = {
  bgcolor: "var(--surface)",
  borderRadius: "var(--radius-xl)",
  boxShadow: "var(--shadow-md)",
  p: { xs: 3, sm: 4 },
} as const;

/** Genummerde stap-badge (Fraunces-cijfer in een cirkel). */
export const stepBadge = {
  width: 44,
  height: 44,
  borderRadius: "50%",
  flexShrink: 0,
  bgcolor: "var(--surface)",
  border: "1px solid var(--primary-200)",
  color: "var(--primary-700)",
  display: "grid",
  placeItems: "center",
  fontFamily: "var(--font-display)",
  fontSize: "1.3rem",
  fontWeight: 600,
} as const;

/** Donker, warm paneel (semantic.dark-tokens) — het ene contrastmoment. */
export const darkPanel = {
  bgcolor: "#2A231C",
  color: "#EDE6DA",
  borderRadius: "var(--radius-xl)",
} as const;

/** Rustige intro-animatie; prefers-reduced-motion schakelt dit uit (index.css). */
export const fadeUp = (delay = 0) => ({ animation: `fade-up .5s ease-out ${delay}ms both` });
